import React, { useEffect, useState } from 'react'
import LanguageSelect from 'components/LanguageSelect'
import { useDispatch, useSelector } from 'react-redux'
import { langList, SS } from 'utils/common'
import { getLocale } from 'store/root-thunk'
import { setLanguage } from 'store/root-slices'
import _ from 'lodash'

const getShopLanguage = (options, locale) => {
	return _.find(options, (i) => i.value === locale)
}

const LanguageSwitcher = () => {
	const dispatch = useDispatch()
	const { shopId, locale, messages } = useSelector((state) => state.root)
	const options = useSelector(
		(state) => state.root.shopProperties['widget.supported.languages']
	)
	const shopLanguage = useSelector((state) => {
		return state.root.shopProperties['shop.language'] || 'en'
	})

	const [width, setWidth] = useState(window.innerWidth)
	const handleResize = () => {
		setWidth(window.innerWidth)
	}
	useEffect(() => {
		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [width])

	/**
	 * handlerLanguageSwitcher {Function}
	 * @description
	 * - switches languages for the application, there are 2 variants in the action:
	 * - first case makes a request to the server and receives translations
	 * - second when we look in Redux and if there is already a translation, we take it from the Redux.
	 * */
	const handlerLanguageSwitcher = ({ value }) => {
		let defaultValue = value ? value : shopLanguage
		if (shopId && messages[value]) {
			dispatch(setLanguage(value))
		} else {
			dispatch(getLocale(shopId, defaultValue))
		}
		SS.set('language', value)
	}
	let langListOptions = langList(options)

	return (
		langListOptions?.length > 1 && (
			<LanguageSelect
				onChange={handlerLanguageSwitcher}
				options={langList(options)}
				isSearchable={false}
				value={getShopLanguage(langList(options), locale)}
			/>
		)
	)
}
export default LanguageSwitcher
